import type { Type } from '@angular/core';
import { inject, InjectionToken, ViewContainerRef } from '@angular/core';

import type { Observable } from 'rxjs';
import { of, switchMap } from 'rxjs';

import type { CandidateSelectOption } from '@core/search-types';
import type { DialogRef } from '@core/user-interface-legacy';
import { DialogService, DialogWidth } from '@core/user-interface-legacy';

import type { SharingContainerApi } from './containers.types';

export interface ShareCandidateDialogData {
  tab?: string;
  container?: SharingContainerApi | null;
  candidates?: CandidateSelectOption[] | null;
}

export interface ShareCandidateDialogCloseData {
  visibleSections: string[];
  editableSections: string[];
  candidates: number;
  exists: boolean;
  container: Partial<SharingContainerApi>;
}

const SHARE_CANDIDATE_DIALOG = new InjectionToken<Observable<Type<any>>>('SHARE_CANDIDATE_DIALOG');

export const injectShareCandidateDialog = () => inject(SHARE_CANDIDATE_DIALOG);
export const provideShareCandidateDialog = (cmpClass$: Observable<Type<any>>) => ({
  provide: SHARE_CANDIDATE_DIALOG,
  useValue: cmpClass$,
});

export const injectShareCandidateDialogOpener = (
  vcRef: ViewContainerRef | null = inject(ViewContainerRef),
) => {
  const cmpClass$ = inject(SHARE_CANDIDATE_DIALOG);
  const dialogSvc = inject(DialogService);

  return (data: ShareCandidateDialogData) =>
    cmpClass$.pipe(
      switchMap((cmp: Type<any>) =>
        of<DialogRef<any, ShareCandidateDialogCloseData>>(
          dialogSvc.custom(cmp, { width: DialogWidth.Medium }, data, vcRef),
        ),
      ),
    );
};
